document.addEventListener("DOMContentLoaded", () => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    // Delegación de eventos
    document.body.addEventListener("click", async (e) => {
        // Buscamos el botón más cercano (por si el click fue en un ícono dentro del botón)
        const btn = e.target.closest("button") || e.target.closest("a");
        if (!btn) return;

        const action = btn.dataset.action;
        if (!action) return;

        // Prevenimos comportamiento default por si usaste <a> en vez de <button>
        e.preventDefault();

        try {
            switch(action) {
                case "accept":
                    await postAction(`/reconciliations/${btn.dataset.type}/matches/${btn.dataset.index}/accept`);
                    removeRowAndRefresh(btn.dataset.type, btn.dataset.index);
                    break;

                case "deny":
                    await postAction(`/reconciliations/${btn.dataset.type}/matches/${btn.dataset.index}/deny`);
                    removeRowAndRefresh(btn.dataset.type, btn.dataset.index);
                    break;

                case "accept-all":
                    await postAction(`/reconciliations/${btn.dataset.type}/matches/accept_all`);
                    reloadMatchesSection(btn.dataset.type);
                    break;

                case "modal-accept":
                    // Aceptamos el ítem desde el modal
                    await postAction(`/reconciliations/${btn.dataset.type}/solo_en_sistema/${btn.dataset.index}/accept`);

                    // 1. Recargamos la tabla principal de matches (fondo)
                    reloadMatchesSection(btn.dataset.type);

                    // 2. Recargamos la página actual del modal para quitar el item aceptado
                    // Obtenemos la página actual guardada en algún lado o buscamos el botón activo,
                    // pero para simplificar, recargamos la página 1 o mantenemos la actual si la guardamos.
                    // Truco: buscar el botón de página activa en el modal si existe, o default 1.
                    const currentPageBtn = document.querySelector('#dynamicModal .pagination .active a');
                    const currentPage = currentPageBtn ? currentPageBtn.innerText : 1;

                    // Recuperamos el título actual para no perderlo
                    const currentTitle = document.getElementById("modalTitle")?.textContent;
                    openModal(btn.dataset.type, 'solo_en_sistema', currentTitle, currentPage);
                    break;

                // --- AQUÍ ESTABA EL ERROR ---
                case "modal-change-page":
                    // Recuperamos el título actual del modal para volver a pasarlo
                    const existingTitle = document.getElementById("modalTitle")?.textContent;

                    // Pasamos: type, which, title, PAGE (4to argumento)
                    openModal(btn.dataset.type, btn.dataset.which, existingTitle, btn.dataset.page);
                    break;

                case "close-modal":
                    const modalEl = document.getElementById("dynamicModal");
                    const modal = bootstrap.Modal.getInstance(modalEl);
                    if (modal) modal.hide();
                    break;
            }
        } catch (err) {
            alert("Ocurrió un error: " + (err.message || err));
            console.error(err);
        }
    });

    // --- FUNCIONES AUXILIARES ---

    async function postAction(path) {
        if(!csrfToken) console.error("CSRF Token no encontrado");

        const resp = await fetch(path, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken,
                "Accept": "application/json"
            },
            body: JSON.stringify({})
        });
        if (!resp.ok) {
            const data = await resp.json().catch(()=>({}));
            throw new Error(data.error || resp.statusText);
        }
        return resp.json();
    }

    function removeRowAndRefresh(tipo, index) {
        const row = document.getElementById(`${tipo}_match_row_${index}`);
        if (row) {
            row.style.opacity = '0.5'; // Feedback visual rápido
        }
        reloadMatchesSection(tipo);
    }

    async function reloadMatchesSection(tipo, page = 1) {
        const params = new URLSearchParams({ [`page_${tipo}`]: page, per_page: 25 });
        const resp = await fetch(`/reconciliations/results?${params.toString()}`, {
            headers: { "Accept": "text/html" }
        });
        const text = await resp.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        // Reemplazamos el contenedor específico
        const newContainer = doc.getElementById(`${tipo}_matches_container`);
        const currentContainer = document.getElementById(`${tipo}_matches_container`);

        if (newContainer && currentContainer) {
            currentContainer.replaceWith(newContainer);
        } else {
            // Fallback por si algo falla en la estructura
            window.location.reload();
        }
    }

    // Función OpenModal corregida
    function openModal(type, which, title = null, page = 1) {
        const modalEl = document.getElementById("dynamicModal");
        const modalBody = modalEl.querySelector("#modalBody");
        const modalTitle = modalEl.querySelector("#modalTitle");

        // Si pasamos título, lo actualizamos. Si no, mantenemos el que está o generamos uno default.
        if (title) {
            modalTitle.textContent = title;
        } else if (!modalTitle.textContent.trim()) {
            modalTitle.textContent = `${type.toUpperCase()} - ${which.replace(/_/g, ' ')}`;
        }

        // Feedback de carga (Opcional: puedes poner un spinner bonito de Metronic)
        modalBody.innerHTML = `
            <div class="d-flex justify-content-center align-items-center py-10">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
            </div>`;

        // Construimos URL con URLSearchParams para evitar errores de sintaxis
        const params = new URLSearchParams({ type: type, which: which, page: page });

        fetch(`/reconciliations/modal_list?${params.toString()}`)
            .then(response => {
                if (!response.ok) throw new Error("Error al cargar contenido del modal");
                return response.text();
            })
            .then(html => {
                modalBody.innerHTML = html;

                // Inicializar tooltips o componentes de Metronic si es necesario
                // KTMenu.createInstances();
                // KTApp.initBootstrapTooltips();

                const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                modal.show();
            })
            .catch(error => {
                console.error(error);
                modalBody.innerHTML = `<div class='alert alert-danger'>Error al cargar datos: ${error.message}</div>`;
            });
    }

    // Exponer globalmente para los onclick del HTML (aunque lo ideal es usar data-attributes y el listener global)
    window.openModal = openModal;
});